import React, { Component } from "react";
import "../css/cartItem.css";
import { FaTimesCircle } from 'react-icons/fa';
import PlanPage from "./PlanPage";

class DesktopCartItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            hidden: false,
            openPlanPage: false
        }
    }

    render() {
        var item = this.props.item;
        const planId = item.planId;
        const bedrooms = item.bedrooms;
        const bathrooms = item.bathrooms;
        const total_sqft = item.total_sqft;
        const levels = item.levels;
        const image = item.main_image;
        const packageName = item.packageName;
        const packagePrice = item.packagePrice;
        const foundation = item.foundation;
        const foundationPrice = item.foundationPrice;

        var hidden = {};
        if (this.state.hidden == true) {
            hidden = { height: "0px", marginTop: "0px", opacity: 0 };
        }

        return (
            <div>
                {this.renderPlanPage()}

                <div style={hidden} className="cart_favoriteHolder">

                    {this.renderRemoveButton()}

                    <div style={{ cursor: "pointer" }} onClick={() => { this.setState({ openPlanPage: true }) }} className="cart_row1">
                        <img className="cart_mainImage" src={"https://www.houseplanstore.com/media/" + image} />
                        <div className="cart_planInfo">
                            <span className="cart_favoritePlanId">{planId}</span><br />
                            <span className="cart_text">Levels: <strong>{levels}</strong></span><br />
                            <span className="cart_text">Bedrooms: <strong>{bedrooms}</strong></span><br />
                            <span className="cart_text">Bathrooms: <strong>{bathrooms}</strong></span><br />
                            <span className="cart_text">Sqft: <strong>{total_sqft}</strong></span>
                        </div>
                    </div>

                    <div className="cart_row2">
                        <div className="cart_itemRow">
                            <div style={{ flex: 5 }}>{packageName}</div>
                            <div style={{ flex: 1, textAlign: "right" }}>${packagePrice}</div>
                        </div>
                        <div className="cart_itemRow">
                            <div style={{ flex: 3 }}>Foundation</div>
                            <div style={{ flex: 2, textAlign: "right" }}>{foundation} (${foundationPrice})</div>
                        </div>
                        {this.renderExtras()}

                    </div>

                </div>
            </div>
        );
    }

    renderRemoveButton = () => {
        console.log("item step",this.props.step)
        if (this.props.step == 0) {
            return (
                <div onClick={() => { this.removeItem() }} className="cart_removeButton"><FaTimesCircle /></div>
            );
        }
    }

    renderExtras = () => {
        //if (!!this.props.item.extras) {
        var array = [];
        for (var i = 0; i < Object.keys(this.props.item.extras).length; i++) {
            array.push(
                <div key={i} className="cart_itemRow">
                    <div style={{ flex: 5 }}>{this.props.item.extras[i][0]}</div>
                    <div style={{ flex: 1, textAlign: "right" }}>${this.props.item.extras[i][1]}</div>
                </div>
            );
        }
        return array;

    }

    removeItem = () => {
        var cartContentsArray = JSON.parse(localStorage.getItem('cart'));
        for (var i = 0; i < cartContentsArray.length; i++) {
            if (cartContentsArray[i].planId == this.props.item.planId) {
                //found array key with matching .planId, remove this key
                cartContentsArray.splice(i, 1);
            }
        }
        localStorage.setItem('cart', JSON.stringify(cartContentsArray));
        this.setState({ hidden: true });
        var refreshSubtotal = this.props.refreshSubtotal;
        refreshSubtotal();
    }

    updateFunction = () => {
        this.setState({ openPlanPage: !this.state.openPlanPage });
    }


    renderPlanPage = () => {
        if (this.state.openPlanPage == true) {
            window.open('https://www.houseplanstore.com/plans/types/houseplans/plan/' + this.props.item.planId + '/', '_blank');
            this.setState({ openPlanPage: false });
        }
    }

}

export default DesktopCartItem;